import { BasicWindow } from "./BasicWindow";
import { Global } from "../../utils/Global";
import { BasicButton } from "../BasicButton";

export class PauseMenu extends BasicWindow {
  private titleText!: Phaser.GameObjects.BitmapText;
  private continueButton!: BasicButton;
  private mainMenuButton!: BasicButton;

  private onContinueCallback?: () => void;
  private onMainMenuCallback?: () => void;

  constructor(scene: Phaser.Scene) {
    super(
      scene,
      0, // x
      0, // y
      300, // width
      200, // height
      "Button1", // textureKey
      "", // frameKey
      300, // sliceWidth
      200, // sliceHeight
      7, // leftWidth
      7, // topHeight
      7, // rightWidth
      7, // bottomHeight
    );

    this.createContent();
    this.setDepth(30000); // Highest - above everything
  }

  private createContent(): void {
    const contentContainer = this.getContentContainer();
    const fontSize = Global.minFontSize;
    const buttonWidth = 200;
    const buttonHeight = 40;
    const spacing = fontSize * 0.5;

    // Title
    this.titleText = new Phaser.GameObjects.BitmapText(
      this.scene,
      0,
      -60,
      "fnt_paintBasic",
      "PAUSED",
      fontSize * 1.5,
    ).setOrigin(0.5);
    contentContainer.add(this.titleText);

    // Continue Button
    this.continueButton = new ContinueButton(this.scene, () => {
      this.hide(() => {
        if (this.onContinueCallback) {
          this.onContinueCallback();
        }
      });
    });
    this.continueButton.Resize(buttonWidth, buttonHeight);
    this.continueButton.setPosition(0, -10);
    contentContainer.add(this.continueButton);

    // Main Menu Button
    this.mainMenuButton = new MainMenuButton(this.scene, () => {
      this.hide(() => {
        if (this.onMainMenuCallback) {
          this.onMainMenuCallback();
        }
      });
    });
    this.mainMenuButton.Resize(buttonWidth, buttonHeight);
    this.mainMenuButton.setPosition(0, buttonHeight + spacing);
    contentContainer.add(this.mainMenuButton);
  }

  public showPauseMenu(onContinue?: () => void, onMainMenu?: () => void): void {
    this.onContinueCallback = onContinue;
    this.onMainMenuCallback = onMainMenu;

    // Center the pause menu on screen
    const x = this.scene.scale.width / 2;
    const y = this.scene.scale.height / 2;
    this.setPosition(x, y);

    // Show immediately without animation since tweens might be paused
    this.setScale(1);
    this.setAlpha(1);
    this.setVisible(true);
  }

  public hidePauseMenu(): void {
    this.hide();
  }

  public override destroy(): void {
    this.scene.tweens.killTweensOf(this);
    super.destroy();
  }
}

// Custom button classes for the pause menu
class ContinueButton extends BasicButton {
  private onClickCallback?: () => void;

  constructor(scene: Phaser.Scene, onClickCallback?: () => void) {
    super(
      scene,
      "Continue",
      { textureKey: "Button1" },
      { textureKey: "Button2" },
      { textureKey: "Button1" },
      undefined,
    );
    this.background.setTint(0xac4c3f);
    this.onClickCallback = onClickCallback;
  }

  handlePointerDown(): void {
    // Visual feedback handled by parent class
  }

  handlePointerUp(): void {
    if (this.onClickCallback) {
      this.onClickCallback();
    }
  }

  handlePointerOver(): void {
    // Visual feedback handled by parent class
  }

  handlePointerOut(): void {
    // Visual feedback handled by parent class
  }
}

class MainMenuButton extends BasicButton {
  private onClickCallback?: () => void;

  constructor(scene: Phaser.Scene, onClickCallback?: () => void) {
    super(
      scene,
      "Main Menu",
      { textureKey: "Button1" },
      { textureKey: "Button2" },
      { textureKey: "Button1" },
      undefined,
    );
    this.background.setTint(0xac4c3f);
    this.onClickCallback = onClickCallback;
  }

  handlePointerDown(): void {
    // Visual feedback handled by parent class
  }

  handlePointerUp(): void {
    if (this.onClickCallback) {
      this.onClickCallback();
    }
  }

  handlePointerOver(): void {
    // Visual feedback handled by parent class
  }

  handlePointerOut(): void {
    // Visual feedback handled by parent class
  }
}
